import React from 'react';
import Icon from "@material-ui/core/Icon/Icon";

export const MIcon = ({style, className}) => (
    <Icon style={style} className={className}/>
);